import { getArticleGroups, getCutOffCampaignByName } from "apis/orderCutOffApi";
import { doCall } from "common/genericSaga";
import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  ARTICLE_GROUPS_REQUESTED,
  ARTICLE_GROUPS_REQUEST_FAILED,
  CUTOFF_CAMPAIGN_REQUESTED,
  CUTOFF_CAMPAIGN_REQUEST_FAILED,
  receiveArticleGroups,
  receiveCutoffCampaign
} from "./cutoffActions";

export function* doRequestArticleGroups(action, requestInfo) {
  const articleGroups = yield call(getArticleGroups, requestInfo);
  yield put(receiveArticleGroups(articleGroups));
}

export function* doRequestCutoffCampaign(action, requestInfo) {
  const campaign = yield call(getCutOffCampaignByName, requestInfo, action.name);
  yield put(receiveCutoffCampaign(campaign));
}

export function* watchCutoff() {
  yield all([
    takeEvery(ARTICLE_GROUPS_REQUESTED, doCall(doRequestArticleGroups, ARTICLE_GROUPS_REQUEST_FAILED)),
    takeEvery(CUTOFF_CAMPAIGN_REQUESTED, doCall(doRequestCutoffCampaign, CUTOFF_CAMPAIGN_REQUEST_FAILED))
  ]);
}
